export const RoleNames = Object.freeze({
  OrdinaryAdmin: "OrdinaryAdmin",
  SuperAdmin: "SuperAdmin",
  Accounter: "Accounter",
  Supporter: "Supporter",
  MarketplaceEditor: "MarketplaceEditor",
  MarketplacePartner: "MarketplacePartner",
  NewsEditor: "NewsEditor",
});

const ROLE_AUTHORITY = Object.freeze({
  [RoleNames.Accounter]: [
    RoleNames.Supporter,
    RoleNames.OrdinaryAdmin,
    RoleNames.SuperAdmin,
  ],
  [RoleNames.Supporter]: [RoleNames.OrdinaryAdmin, RoleNames.SuperAdmin],
  [RoleNames.OrdinaryAdmin]: [RoleNames.SuperAdmin],
  [RoleNames.MarketplaceEditor]: [
    RoleNames.OrdinaryAdmin,
    RoleNames.SuperAdmin,
  ],
  [RoleNames.NewsEditor]: [RoleNames.OrdinaryAdmin, RoleNames.SuperAdmin],
  [RoleNames.MarketplacePartner]: [
    RoleNames.MarketplaceEditor,
    RoleNames.OrdinaryAdmin,
    RoleNames.SuperAdmin,
  ],
});

export const hasAuthorityOver = (actingRoles, targetRole) => {
  const roles = Array.isArray(actingRoles) ? actingRoles : [actingRoles];
  return (ROLE_AUTHORITY[targetRole] ?? []).some((role) =>
    roles.includes(role),
  );
};

export const selectUserRoles = (state) => state.auth?.roles ?? [];
